import { ChainNetwork, utils } from '@cronos-app/sdk';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const IS_GLOBAL_CONTEXT_DISABLED = process.env.NODE_ENV !== 'development' &&
    (process.env.APP_ENV === 'uat' || process.env.APP_ENV === 'prod');
const DEFAULT_NETWORK_OF_ENV = process.env.APP_ENV === 'uat' || process.env.APP_ENV === 'prod'
    ? ChainNetwork.mainnet
    : ChainNetwork.testnet;
/**
 * prevent from using this store directly, use wrapped hooks instead
 */
export const useGlobalContextStore = create(persist(() => ({
    chainNetwork: DEFAULT_NETWORK_OF_ENV,
}), {
    name: '__GLOBAL_CONTEXT__',
    version: 3,
}));
export const useDesiredNetwork = IS_GLOBAL_CONTEXT_DISABLED
    ? () => DEFAULT_NETWORK_OF_ENV
    : () => {
        return useGlobalContextStore((s) => s.chainNetwork);
    };
export const useDesiredChain = (chainLayer) => {
    const chainNetwork = useDesiredNetwork();
    return utils.getChainOfLayer(chainLayer, chainNetwork);
};
